import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import RegistrationPage from './pages/RegistrationPage';
import PreferencesPage from './pages/PreferencesPage';
import SuccessPage from './pages/SuccessPage';

/**
 * App — root layout and route definitions.
 *
 * Wraps every page in the shared Header / Footer chrome and defines
 * the three application routes plus a catch-all redirect to `/`.
 *
 * Routes:
 *  - `/`  and `/index.html`        → RegistrationPage  (anonymous)
 *  - `/preferences` and `.html`    → PreferencesPage   (personalized, needs `rid`)
 *  - `/success`                    → SuccessPage        (post-registration)
 */
export default function App() {
  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<RegistrationPage />} />
          <Route path="/index.html" element={<RegistrationPage />} />
          <Route path="/preferences" element={<PreferencesPage />} />
          <Route path="/preferences.html" element={<PreferencesPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
